import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

type Theme = 'dark' | 'light'

interface ThemeState {
  theme: Theme
  toggleTheme: () => void
  setTheme: (theme: Theme) => void
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: 'dark',
      toggleTheme: () => set((state) => ({ theme: state.theme === 'dark' ? 'light' : 'dark' })),
      setTheme: (theme) => set({ theme }),
    }),
    {
      name: 'theme-storage',
      storage: createJSONStorage(() => {
        // Verifica se está no navegador
        if (typeof window !== 'undefined') {
          return localStorage
        }
        // Retorna um storage vazio para SSR
        return {
          getItem: () => null,
          setItem: () => null,
          removeItem: () => null,
        }
      }),
      skipHydration: true,
    }
  )
) 